module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductClassfiyView.js"));
	}, "ApplicationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ApplicationView!./src/pages/Shop/Home/ProductClassfiy/ProductClassfiyView.js
// module id = 1840
// module chunks = 367